package org.example.site_web.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initIndeffiPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Indeffi.md", FrontMatterElement.Builder { addScalar("title", "About"); }))
}

@Page("/indeffi")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun IndeffiPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("le-projet-indeffi") }) {
        org.jetbrains.compose.web.dom.Text("Le projet Indeffi")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Soutenu par l'incubateur Emergys, dispositif de la région Bretagne et avec le soutien de la technopole de Lorient, Accelarge porte le projet Ind&Fi \"Indépendant et efficace\" visant à développer et proposer un outil facilitant la gestion au quotidien pour travailleurs indépendants et itinérants.")
    }
}
